import { ResultCode } from '@iotize/tap/client/api';

export class TapServerError extends Error {
    static targetComError() {
        return new TapServerError(ResultCode.TARGET_PROTOCOL_ERROR);
    }
    
    static internalError(msg?: string) {
        return new TapServerError(ResultCode.INTERNAL_SERVER_ERROR, msg);
    }

    static badRequest() {
        return new TapServerError(ResultCode.BAD_REQUEST);
    }
    
    static notImplemented() {
        return new TapServerError(ResultCode.NOT_IMPLEMENTED);
    }

    static notAvailable() {
        return new TapServerError(ResultCode.SERVICE_UNAVAILABLE);
    }

    static notAcceptable() {
        return new TapServerError(ResultCode.NOT_ACCEPTABLE);
    }

    static notFound() {
        return new TapServerError(ResultCode.NOT_FOUND);
    }

    static unauthorized() {
        return new TapServerError(ResultCode.UNAUTHORIZED);
    }

    constructor(public resultCode: number, additionalMsg?: string) {
        super(`Tap server error. Result code: ${resultCode}.${additionalMsg ? additionalMsg : ''}`);
    }

    static requestError(resultCode: number) {
        return new TapServerError(resultCode);
    }

}